import linkedin from '@/assets/external-profiles/social-icon-in.png'
import twitter from '@/assets/external-profiles/twitter.png'
import facebook from '@/assets/external-profiles/social-icon-fb.png'

const socials = [
  { icon: facebook, code: 'fb', label: 'Facebook', urlPrefix: 'https://facebook.com/shareArticle/?mini=true&url=' },
  { icon: twitter, code: 'twitter', label: 'Twitter', urlPrefix: 'https://twitter.com/intent/tweet?' },
  { icon: linkedin, code: 'linkedin', label: 'LinkedIn', urlPrefix: 'https://www.linkedin.com/shareArticle/?mini=true&url=' }
]

export {
  socials
}



// WEBPACK FOOTER //
// ./src/helpers/external-socials.js